<form *ngIf="replace || !ccInfo" [formGroup]="ccForm" (ngSubmit)="save()">
  <div class="_2-up-grid">
    <div class="full-row">
      <div class="title">
        <label for="cardHolderName">Cardholder&rsquo;s Name</label>
      </div>
      <input
        type="text"
        class="text-input w-input"
        maxlength="256"
        formControlName="cardHolderName"
        id="cardHolderName"
      />
    </div>
    <div class="full-row">
      <div class="title">
        <label for="cardNumber">Card Number</label>
      </div>
      <input type="tel" class="text-input w-input" formControlName="cardNumber" id="cardNumber" cntMaskCCNum />
    </div>
    <div class="exp-wrapper">
      <div class="title">
        <label for="cardExpMonth">Expiration Date</label>
      </div>
      <ng-select
        class="dropdown w-dropdown dropdown-toggle"
        formControlName="cardExpMonth"
        id="cardExpMonth"
        [clearable]="false"
        placeholder="Select Month"
      >
        <ng-option [value]="'01'">January - 01</ng-option>
        <ng-option [value]="'02'">February - 02</ng-option>
        <ng-option [value]="'03'">March - 03</ng-option>
        <ng-option [value]="'04'">April - 04</ng-option>
        <ng-option [value]="'05'">May - 05</ng-option>
        <ng-option [value]="'06'">June - 06</ng-option>
        <ng-option [value]="'07'">July - 07</ng-option>
        <ng-option [value]="'08'">August - 08</ng-option>
        <ng-option [value]="'09'">September - 09</ng-option>
        <ng-option [value]="'10'">October - 10</ng-option>
        <ng-option [value]="'11'">November - 11</ng-option>
        <ng-option [value]="'12'">December - 12</ng-option>
      </ng-select>
    </div>
    <div class="exp-wrapper">
      <label for="cardExpYear" class="sr-only">Expiration Date - Year</label>
      <ng-select
        class="dropdown w-dropdown dropdown-toggle"
        formControlName="cardExpYear"
        id="cardExpYear"
        [clearable]="false"
        placeholder="Select Year"
      >
        <ng-option *ngFor="let year of expirationYears" [value]="year">
          {{ year }}
        </ng-option>
      </ng-select>
    </div>
    <div>
      <div class="title">
        <label for="cardCvv">Security Code</label>
      </div>
      <input type="tel" class="text-input w-input" formControlName="cardCvv" id="cardCvv" cntMaskCCCvc />
    </div>

    <div></div>

    <h4>Billing Address</h4>

    <div class="full-row">
      <div class="title">
        <label for="address">Billing Address</label>
      </div>
      <input id="address" type="text" [formControl]="address" name="address" class="text-input w-input" />
    </div>

    <div>
      <div class="title">
        <label for="city">Billing City</label>
      </div>
      <input id="city" type="text" [formControl]="city" name="city" class="text-input w-input" />
    </div>

    <div>
      <div class="title">
        <label for="state">Billing State</label>
      </div>
      <input id="state" type="text" [formControl]="state" name="state" class="text-input w-input" />
    </div>

    <div>
      <div class="title">
        <label for="zipcode">Billing ZIP Code</label>
      </div>
      <input id="zipcode" type="text" [formControl]="zipcode" name="zipcode" class="text-input w-input" />
    </div>

    <div></div>

    <button id="user-cc-save-button" type="submit" class="button trinidad center w-button">Save Credit Card</button>
  </div>
</form>

<div *ngIf="!replace && ccInfo">
  <h4>Existing Card</h4>

  <div class="_2-up-grid">
    <div>
      <div class="title">
        <label for="editCardType">Card Type</label>
      </div>
      <input id="editCardType" type="text" class="text-input w-input" disabled value="{{ ccInfo?.type }}" />
    </div>
    <div>
      <div class="title">
        <label for="editCardNumber">Card Number</label>
      </div>
      <input id="editCardNumber" type="tel" class="text-input w-input" disabled value="{{ ccInfo?.number }}" />
    </div>
    <div>
      <div class="title">
        <label for="editCardExpiration">Expiration Date</label>
      </div>
      <input
        id="editCardExpiration"
        type="tel"
        class="text-input w-input"
        disabled
        value="{{ ccInfo?.expire | cardExpiration }}"
      />
    </div>

    <button id="user-cc-remove-button" type="button" class="button trinidad center w-button" (click)="replace = true">
      Replace Credit Card
    </button>
  </div>
</div>
